import styled, {css} from 'styled-components';

export const Actions = styled.div`
  text-align: center;

  ${({theme}) => css`
    margin-top: ${theme.spacing.s2};
  `}
`;

export const ActionsRow = styled.div`
  margin: ${({theme}) => theme.spacing.s6} 0;
`;
